import { getCurrentUser } from './actions';

export const defaultState = {
  userData: {}
};

const user = (state = defaultState, action) => {
  switch (action.type) {
    case getCurrentUser.event.success: {
      return {
        ...state,
        userData: action.payload
      };
    }

    default:
      return state;
  }
};

export default user;
